<template>
  <div class="people-list">
    <!-- Header with Title and Search -->
    <div class="list-header">
      <h2 class="list-title">List of people</h2>
    </div>

    <!-- People List -->
    <div class="people-container">
      <div
        v-for="person in filteredPeople"
        :key="person.id"
        class="person-item"
        @click="handlePersonClick(person)"
      >
        <!-- Profile Image -->
        <div class="person-avatar">
          <img :src="!person.profilImgMini1? require('./img/profile.svg') : bsUrl+person.profilImgMini1"  />
        </div>

        <!-- Person Info -->
        <div class="person-info">
          <div class="person-name">{{ person.pseudo }}</div>
          <div class="person-stats">
            <svg fill="currentColor" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2,22H18.644a3.036,3.036,0,0,0,3-2.459l1.305-7a2.962,2.962,0,0,0-.637-2.439A3.064,3.064,0,0,0,19.949,9H15.178V5c0-2.061-2.113-3-4.076-3a1,1,0,0,0-1,1c0,1.907-.34,3.91-.724,4.284L6.593,10H2a1,1,0,0,0-1,1V21A1,1,0,0,0,2,22ZM8,11.421l2.774-2.7c.93-.907,1.212-3.112,1.3-4.584.542.129,1.109.38,1.109.868v5a1,1,0,0,0,1,1h5.771a1.067,1.067,0,0,1,.824.38.958.958,0,0,1,.21.8l-1.3,7A1.036,1.036,0,0,1,18.644,20H8ZM3,12H6v8H3Z"/></svg>
            <span>{{ formatNumber(person.stats?.likes) }} like{{ person.stats?.likes !== 1 ? 's' : '' }}</span>
          </div>
        </div>

        <!-- Follow/Unfollow Button -->
        <button
          v-show="person.uid !== $store.state.user.uid"
          @click.stop="toggleFollow(person)"
          :class="['follow-btn', { following: person.following }]"
        >
          {{ person.following ? 'Unfollow' : 'Follow' }}
        </button>
      </div>

      <!-- Empty State -->
      <div v-if="filteredPeople.length === 0" class="empty-state">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
        <p>No people found</p>
      </div>
    </div>
    <Loader :loading="loading" />
    <Profile :visible="false" ref="profile"/>
  </div>
</template>

<script>
import Loader from "@/views/components/loader/Loader.vue"
import Profile from "@/views/profile/Profile.vue"

export default {
  name: 'PeopleList',
  components:{
    Loader,
    Profile
  },
  props: {
    people: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bsUrl:this.$store.state.baseUrl+'images/',
      loading:false,
      searchQuery: '',
      defaultPeople: []
    }
  },
  computed: {
    peopleData() {
      return this.people.length > 0 ? this.people : this.defaultPeople;
    },
    filteredPeople() {
      if (!this.searchQuery.trim()) {
        return this.peopleData;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.peopleData.filter(person => 
        person.name.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    formatNumber(num) {
      if(!num) return 0
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toString();
    },
    handlePersonClick(person) {
      this.$refs.profile.show(person)
    },
    async toggleFollow (person) {
      this.loading = true 
      try {
          const type = person.following ? 'unfollow' : 'follow'
          await this.$axios.post('friendship.php',{type:type,following:person.uid})
          person.following = !person.following
      } catch (e) {
          console.log(e.response)
      } finally {this.loading = false}
    },
    async searchUser (str) {
      this.loading = true 
      try {
          const res = await this.$axios.post('user.php',{type:"searchUser",search:str})
          const usrs = res.data
          const res1 = await this.$axios.post('friendship.php',{type:"followingList"})
          const followings = res1.data
          let i = 0, result = [], blokedUser = this.$store.state.user.blockedUser || []
          for(i=0;i<usrs.length;i++) {
            usrs[i].following = followings?.findIndex((fl)=>fl.uid === usrs[i].uid ) !== -1 // set following to true or false
            if(blokedUser.findIndex((bu)=>(bu.userId == usrs[i].uid && !bu.deletedAt) ) === -1) result.push(usrs[i]) // don't push bloked users
          }
          this.defaultPeople = result
        } catch (e) {
          console.log(e.response)
      } finally {this.loading = false}
    },
    close () {
      if(this.$store.state.audioPlayerVisibility === true) {
        this.$store.commit('setAudioPlayerVisibility',false)
        return false
      }
      if(this.$refs.profile.Display ) {
        this.$refs.profile.hide()
        return false
      }
      return true
    },
  },
  mounted () {
    this.searchUser('.')
  }
}
</script>

<style scoped>
.people-list {
  background: #0a0e26;
  min-height: 100vh;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin-bottom: 110px;
  overflow: auto;
}

/* Header */
.list-header {
  max-width: 800px;
  margin: 0 auto 24px;
}

.list-title {
  color: #94a3b8;
  font-size: 14px;
  font-weight: 600;
  margin: 0px;
  text-align: left;
}


/* People Container */
.people-container {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.people-container > * + * {
  margin-top: 12px;
}
/* Person Item */
.person-item {
  background: rgba(30, 41, 59, 0.6);
  border: 1px solid rgba(0, 212, 255, 0.15);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.person-item:hover {
  background: rgba(30, 41, 59, 0.8);
  border-color: rgba(0, 212, 255, 0.3);
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.15);
}

.person-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(0, 212, 255, 0.3);
  flex-shrink: 0;
  box-shadow: 0 0 15px rgba(0, 212, 255, 0.2);
  margin-right: 16px;
}

.person-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.person-info {
  flex: 1;
  min-width: 0;
  margin-right: auto;
}

.person-name {
  color: #e0f7ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.person-stats {
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 14px;
}

.person-stats svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 6px;
}

.person-stats span {
  white-space: nowrap;
}

/* Follow Button */
.follow-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  flex-shrink: 0;
}

.follow-btn:not(.following) {
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 212, 255, 0.3);
}

.follow-btn:not(.following):hover {
  box-shadow: 0 6px 16px rgba(0, 212, 255, 0.5);
}

.follow-btn.following {
  background: rgba(30, 41, 59, 0.8);
  color: #e0f7ff;
  border: 1px solid rgba(0, 212, 255, 0.3);
}

.follow-btn.following:hover {
  background: rgba(30, 41, 59, 1);
  border-color: rgba(0, 212, 255, 0.5);
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;
}

.empty-state svg {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  opacity: 0.5;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* Responsive */
@media (max-width: 640px) {
  .people-list {
    padding: 16px;
  }

  .person-item {
    padding: 12px;
  }

  .person-avatar {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }

  .person-name {
    font-size: 15px;
  }

  .person-stats {
    font-size: 13px;
  }

  .follow-btn {
    padding: 8px 16px;
    font-size: 13px;
  }
}

@media (max-width: 420px) {
  .follow-btn {
    padding: 8px 12px;
    font-size: 12px;
  }
  
  .person-stats {
    font-size: 12px;
  }
}
</style>